import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { RoleFormComponent } from './role-form.component';
import { SharedModule } from '../../../../shared/shared.module';
import { AdminAccess } from '../../../../shared/accessAdmin';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    TextMaskModule,
    FlexLayoutModule,
  ],
  declarations: [RoleFormComponent],
  exports: [RoleFormComponent],
  providers: [AdminAccess],
})
export class RoleFormModule {}
